import { createLookup, OmniaPromise, omniaResolve } from "../omnia"
import { INtrBalance } from "../types"

export type BalanceProvider = ReturnType<typeof createBalanceProvider>["provider"]

export function createBalanceProvider(load: () => OmniaPromise<INtrBalance[]>) {

    let croppingLoookup: { [croppingId: number]: INtrBalance[] }
    let zonesLoaded = false

    update([])

    const provider = {

        get,
        getWholeField,
        getZones,

        get zonesLoaded() {
            return zonesLoaded
        },

        loadZones,

    }

    return { provider, reset }

    function reset(balance: INtrBalance[]) {
        update(balance, false)
    }

    function loadZones() {

        return zonesLoaded
            ? omniaResolve()
            : reload()

    }

    function reload() {
        return load().then(b => update(b, true))
    }

    function update(balance: INtrBalance[], loaded?: boolean) {
        croppingLoookup = createLookup(balance, b => b.CroppingId)
        zonesLoaded = loaded ?? balance.some(b => !!b.Zone)
    }

    function get(croppingId: number) {
        return croppingLoookup[croppingId] ?? []
    }

    function getWholeField(croppingId: number) {
        const r = croppingLoookup[croppingId] ?? []
        return r.find(b => !b.Zone)
    }

    function getZones(croppingId: number) {

        if (!zonesLoaded) {
            return undefined
        }

        const r = croppingLoookup[croppingId] ?? []
        return r.filter(b => b.Zone)

    }

}
